// @flow
import React from "react";
import { GlobalProvider } from "../common/GlobalContext";
import AccessibilityBody from "./AccessibilityBody";

type $Props = {
  theme: Object,
};

const Accessibility = ({ theme }: $Props) => {
  return (
    <GlobalProvider theme={theme}>
      <AccessibilityBody />
    </GlobalProvider>
  );
};

export default Accessibility;
